import styled from 'styled-components';

import CcFill from 'Assets/mtm/cc-fill.svg';
import Cc from 'Assets/mtm/cc.svg';
import MtmBg from 'Assets/mtm/mtm-bg.png';
import Pause from 'Assets/mtm/pause.svg';
import Play from 'Assets/mtm/play.svg';
import SpeakerOff from 'Assets/mtm/speaker-off.svg';
import SpeakerOn from 'Assets/mtm/speaker-on.svg';
import triangle from 'Assets/mtm/triangle.svg';
import { breakpoint } from 'DesignLibrary/global';
import { SkewHoverKeyframes } from 'DesignLibrary/keyframes';

interface MomentPageLayoutProps {
  topic?: string;
}

interface RuntimeContainerProps {
  cover?: string;
}

export const StorybookRuntimeContainer = styled.div<RuntimeContainerProps>`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding-top: 1rem;
  min-height: calc(-376px + 100vh);
  display: flex;
  align-items: center;
  .mtm {
    width: 100%;
  }
  ${({ cover }) =>
    cover && cover !== ''
      ? `
      [data-started='false'] {
    #playpause {
      width: 100%;
      height: 100%;
      background-size: 100%;
      padding: 0;
      border-radius: 1rem;
      background-image: url('${cover}');
    }
  }
    `
      : ''}
`;

export const MomentPageLayoutWrapper = styled.div<MomentPageLayoutProps>`
  .inner-wrapper {
    max-width: 100%;
    width: 100%;
    background: linear-gradient(0deg, rgb(251, 248, 243) 73.85%, rgb(255, 255, 255) 95.34%);
  }
`;

export const StorybookRuntimeWrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sizing-lg);
  border-radius: 24px;
  box-shadow: 0px 2px 8px 0px #2f2f5229;
  background: #ffffff;
  padding: 16px;
  padding-right: 24px;
  width: 100%;

  video {
    border-radius: 1rem;
    opacity: 0;
    animation: fade 0.4s ease forwards;
    animation-delay: 0.1s;
    @media (max-width: 781px) {
      border-radius: 1rem 1rem 0 0;
    }
  }

  ${breakpoint.DESKTOP} {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  .dreamcast-scope {
    .moment.container {
      padding-top: 56.25%;
    }

    .moment > div:not(.uicontainer),
    .moment > div:not(.uicontainer) > div,
    [data-vjs-player='true'],
    [data-vjs-player='true'] > div,
    video-js {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100% !important;
    }

    .moment > .uicontainer {
      z-index: 60;
    }

    .moment > div:nth-of-type(2) {
      z-index: 50;
    }

    .moment > div:nth-of-type(3) {
      z-index: 40;
    }

    .overlay {
      position: absolute;
      overflow: hidden;
    }

    .question-text {
      font-size: 1.1rem;
      font-weight: 300;
      line-height: 1.3;
      text-align: center;
      margin: 0 auto 1rem;
      flex: 0 0 100%;
      opacity: 0;
      animation: fade 0.3s ease forwards;
      animation-delay: 0.2s;
      @media (min-width: 782px) {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
      }
    }

    .choice {
      display: inline-flex;
      opacity: 0;
      animation: fade 0.3s ease forwards;

      button {
        font-size: 1rem;
        height: 48px;
        border: 2px solid #bebeca;
        background: white;

        @media (max-width: 781px) {
          font-size: 14px;
          height: auto;
          min-height: auto;
          padding-left: 0.6rem;
          padding-right: 0.6rem;
        }

        &:hover {
          border-color: var(--colors-alex-blue);
        }

        &:active,
        &:focus {
          background: var(--colors-alex-blue);
          border-color: var(--colors-alex-blue);
          color: white;
          transform: scale(1);
        }
      }

      &:nth-of-type(1) {
        animation-delay: 1s;
      }
      &:nth-of-type(2) {
        animation-delay: 1.1s;
      }
      &:nth-of-type(3) {
        animation-delay: 1.2s;
      }
    }

    .loading {
      opacity: 0;
      animation: fade 0.1s ease forwards;
      animation-delay: 2.5s;
    }

    .conversation {
      position: relative;
      height: 100%;
      border-radius: 1rem;
      /*
      ${breakpoint.DESKTOP} {
        min-height: 382px;
        .uicontainer,
        .vjs-progress-control {
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        &:hover {
          .uicontainer,
          .vjs-progress-control {
            opacity: 1;
          }
        }
      }
      */
      @media (max-width: 781px) {
        margin-left: -16px;
        width: calc(100% + 32px);
        margin-top: -16px;
        border-radius: 1rem 1rem 0 0;
      }

      .uicontainer {
        position: absolute;
        bottom: 0.5rem;
        left: 1.5%;
        top: auto;
        width: 97%;
        height: 28px;
        display: flex;
        justify-content: space-between;
        pointer-events: none;

        /*
        + div {
          height: 100%;
        }
        */

        #skip {
          display: none;
        }

        #playpause,
        #cc,
        #mute {
          pointer-events: auto;
          background-position: center;
          background-repeat: no-repeat;
          background-color: rgba(255, 255, 255, 0.65);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          &:hover {
            background-color: rgba(255, 255, 255, 0.8);
          }
          &:active {
            background-color: rgba(255, 255, 255, 0.9);
          }
        }

        #cc {
          background-image: url(${Cc});
          background-size: 24px 24px;
          order: 3;

          &.selected {
            background-image: url(${CcFill});
          }
        }

        #playpause {
          background-image: url(${Pause});
          background-size: 18px 18px;
          width: 50px;
          &.selected {
            background-image: url(${Play});
          }
        }

        #mute {
          margin-right: 0.5rem;
          margin-left: auto;
          background-image: url(${SpeakerOn});
          background-size: 18px 18px;
          order: 2;

          &.selected {
            background-image: url(${SpeakerOff});
          }
        }

        .ui-button,
        .ui-button.selected {
          border: 0;
          color: transparent;
        }
      }

      .closedcaption-container {
        position: absolute;
        padding: 0.5rem 1rem;
        background: rgba(47, 47, 82, 0.68);
        border-radius: 0.5rem;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        left: 50%;
        transform: translateX(-50%);
        width: auto;

        .closedcaption-text {
          font-size: 1rem;
          font-weight: 500;
          padding: 0;
          line-height: 1.4;
        }
      }

      video-js {
        padding: 0;
        margin-top: 0;

        .vjs-big-play-button {
          display: block;
          background: rgba(47, 47, 82, 0.8);
          border: 0;
          border-radius: 10rem;
          height: 100px;
          width: 100px;
          left: 70%;
          top: 44%;

          &:hover {
            background: rgba(47, 47, 82, 1);
            animation: ${SkewHoverKeyframes} 2000ms ease-in-out infinite alternate;
            transform: scale(1.04);
          }

          .vjs-icon-placeholder:before {
            content: '';
            display: block;
            width: 60px;
            height: 60px;
            background: url(${triangle}) no-repeat center center;
            background-size: 60px 60px;
            top: 22%;
            left: 25%;
          }
        }

        &.vjs-playing,
        &.vjs-has-started {
          .vjs-big-play-button {
            display: none;
          }
        }

        .vjs-control-bar {
          display: flex !important;
          visibility: hidden;

          .vjs-time-tooltip {
            display: none;
          }

          .vjs-load-progress {
            display: none;
          }

          .vjs-progress-control {
            display: flex;
            visibility: visible;
            position: absolute;
            width: calc(100% - 50px - 90px - 5rem);
            left: calc(50px + 2rem);
            right: calc(90px + 2rem + 1rem);
            overflow: hidden;
            margin: 0;
            bottom: 8px;
            right: 0;

            .vjs-progress-holder {
              margin: 0;
              height: 7px;
              background: rgba(205, 205, 205, 0.25);
              border: 1px solid rgba(0, 0, 0, 0.09);
              border-radius: 99px;
            }

            .vjs-play-progress {
              &:before {
                display: none;
              }
              border-radius: 99px;
            }
          }
        }
      }

      .row.single-column-half-width {
        display: flex;
        height: 100%;
        background: var(--colors-alex-blue10) url(${MtmBg}) no-repeat center center;
        border-radius: 1rem;
        opacity: 0;
        animation: fade 0.4s ease forwards;
        @media (max-width: 781px) {
          border-radius: 1rem 1rem 0 0;
        }

        [class^='col-'] {
          float: none;
          width: 100%;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          align-items: center;
          justify-content: center;
          gap: 0 1.5rem;
          padding: 5rem 0;

          &:empty {
            display: none;
          }

          ${breakpoint.DESKTOP} {
            padding: 0.5rem;
          }
        }
      }
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const MomentSidebarContainer = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RatingsContainer = styled.div`
  padding-top: var(--sizing-lg);
  padding-bottom: var(--sizing-xxl);
  text-align: center;
  max-width: 415px;
  margin: 0 auto;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
